import { useDispatch } from "react-redux"
import Modal from "../../../../../commons/Modal/Modal"
import Button from "../../../../../designSystem/Button/Button"
import { ButtonColor } from "../../../../../designSystem/Button/Button.types"
import { PhonePaymentModalProps } from "./PhonePaymentModal.types"
import { signOut } from "../../../../../../store/authentication/authenticationActions/authenticationActions"
import { useQueryClient } from "react-query"
import { useNavigate } from "react-router-dom"
import { ModalSizes } from "../../../../../commons/Modal/Modal.types"
import { useCurrentUser } from "../../../../../../hooks/useCurrentUser/useCurrentUser"
import { UserENT } from "../../../../../../types/models/user/user.types"

export default (props: PhonePaymentModalProps) => {
  const navigate = useNavigate()

  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const { id_company } = useCurrentUser() as UserENT

  return (
    <Modal size={ModalSizes.Small} closeOnClickOutside {...props}>
      <p>
        Contactez-nous au <strong>04.48.27.00.25</strong>
      </p>
      <p>
        Votre identifiant: <strong>#{id_company}</strong>
      </p>
      <Button 
        onClick={(e) => {
          e.preventDefault()
          signOut(queryClient)(dispatch)
          navigate('/login/entreprise')
        }} 
        style={{ marginTop: 'var(--spacing-sToM)' }}
        color={ButtonColor.Secondary}
        >
          Sé déconnecter
        </Button>
    </Modal>
  )
}